<template>
    <div id="app">
        <router-view></router-view>
        <!-- <CopyrightIcp></CopyrightIcp> -->
        <el-dialog
                class="brower-V"
                title="系统提示"
                :visible.sync="browerV"
                width="460px">
            <div class="brower-tip">
                <i class="el-icon-warning big-warning"></i>
                <div class="tip-text">
                    <span>暂不支持IE内核</span>
                    <span>请使用谷歌浏览器或360浏览器(极速模式)</span>
                </div>
            </div>
            <div class="b-btn-box">
                <div class="btn-item" v-for="(item,index) in browerArr" :key="index">
                    <img v-if="browerV" class="b-icon" :src="item.src" alt="">
                    <span class="b-text">{{item.name}}</span>
                    <a class="b-link" :href="item.link" target="_blank">点击下载</a>
                    <img class="hoverImg" src="../static/image/360hover.png" alt="">
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CopyrightIcp from './components/common/copyright-icp.vue';
    export default {
        name: 'App',
        components:{
            CopyrightIcp
        },
        data() {
            return {
                browerV: false,
                browerArr: [
                    {
                        name: '谷歌浏览器',
                        link: 'http://dl.pconline.com.cn/download/51614.html',
                        src: '../static/image/chrome.PNG'
                    },
                    {
                        name: '360浏览器',
                        link: 'https://browser.360.cn/se/',
                        src: '../static/image/360.PNG'
                    },
                ]
            }
        },
        created() {
            if (navigator.userAgent.indexOf('Trident') > -1) {
                this.browerV = true;
            }
            ;
            this.linkTo();


        },
        mounted(){
            //增加关闭页面清除localstorage数据20190828
            let _beforeUnload_time = 0, _gap_time = 0;
            window.onunload = function (){
               // window.sessionStorage["tempFlag"] = true;
                _gap_time = new Date().getTime() - _beforeUnload_time;
                if(_gap_time <= 5){
                    let storage = window.localStorage;
                    storage.clear();
                }
                    }
                    //浏览器刷新关闭会先调用这个方法（通过时间差来控制是刷新还是关闭页面）
            window.onbeforeunload = function (){
                //window.sessionStorage["tempFlag"] = true;
                _beforeUnload_time = new Date().getTime();
            }
        },
        methods: {
            linkTo() {
                if (this.isLogin) {
                    //20190615 add
                    let privilegeObj = JSON.parse(localStorage.getItem("loginData")).userPrivilege;
                    let dir;
                    $.each(privilegeObj, function (_key) {
                        if (privilegeObj[_key].children.length == 0) {
                            dir = privilegeObj[_key].name;
                        }else{
                            dir =privilegeObj[_key].children[0].name;
                        }
                        return false;
                    });
                    this.$store.commit('setNavIndex',1);
                    this.$router.push({name: dir});
                } else {
                    this.$router.push({name: 'login'});
                }
            }
        },
        computed: {
            isLogin() {
                return this.$store.state.isLogin
            }
        },
        watch: {
            isLogin(val, oldVal) {
                if (val) {
                    //20190615 add
                    let privilegeObj = JSON.parse(localStorage.getItem("loginData")).userPrivilege;
                    let dir;
                    $.each(privilegeObj, function (_key) {
                        if (privilegeObj[_key].children.length == 0) {
                            dir = privilegeObj[_key].name;
                        }else{
                            dir =privilegeObj[_key].children[0].name;
                        }
                        return false;
                    });
                    this.$store.commit('setNavIndex',1);
                    this.$router.push({name: dir});
                } else {
                    this.$router.push({name: 'login'});
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // 通过 `vm` 访问组件实例
                let isLogin = vm.$store.state.isLogin;
                if (isLogin) {
                    this.$router.push({name: 'home'});
                } else {
                    this.$router.push({name: 'login'});
                }
            })
        }
    }
</script>

<style>

    .brower-V .brower-tip {
        margin-bottom: 10px;
        overflow: hidden;
    }

    .brower-V .el-dialog__header, .brower-V .el-message-box__header {
        height: 35px;
        line-height: 35px;
        background-color: #f3f3f3;
        padding: 0 10px;
        border-radius: 5px;
    }

    .brower-V .el-dialog__title {
        color: #424a53;
        font-size: 13px;
    }

    .brower-V .el-dialog__headerbtn, .brower-V .el-message-box__headerbtn {
        top: 0;
        line-height: 30px;
    }

    .big-warning {
        font-size: 36px;
        color: #ff5961;
        width: 50px;
        float: left;
        margin: 2px;
    }

    .tip-text {
        margin-top: 2px;
        width: calc(100% - 54px);
        float: left;
    }

    .tip-text > span {
        display: block;
        width: 100%;
        height: 18px;
        line-height: 18px;
        font-size: 14px;
        font-weight: 700;
        color: #333;
    }

    .b-btn-box {
        position: relative;
    }

    .btn-item {
        width: 49%;
        display: inline-block;
    }

    .btn-item .b-icon {
        display: block;
        width: 40px;
        margin: 0 auto;
    }

    .btn-item .b-text {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 12px;
    }

    .btn-item .b-link {
        display: block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        background: #23c973;
        color: #fff;
        border-radius: 4px;
        text-align: center;
        margin: 4px auto;
    }

    .btn-item:hover .hoverImg {
        display: block;
    }

    .hoverImg {
        display: none;
        position: absolute;
        top: -20px;
        right: -170px;
        width: 150px;
    }

    .brower-V a {
        text-decoration: none;
        font-size: 12px;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue